// extracted by mini-css-extract-plugin
export var root = "link-module--root--d3057";
export var white = "link-module--white--4c6fb";